export const selectTenantName = state => state.auth.tenant.name ?? null;

export const selectTenantBranding = state => {
  const branding = state.auth.tenant.branding ?? {};

  return {
    logoUrl: branding.logoUrl ?? null,
    faviconUrl: branding.faviconUrl ?? null,
    primaryColor: branding.primaryColor ?? null,
  };
};
